import { render, staticRenderFns } from "./EventBrands.vue?vue&type=template&id=ab0deed2&"
import script from "./EventBrands.vue?vue&type=script&lang=js&"
export * from "./EventBrands.vue?vue&type=script&lang=js&"
import style0 from "./EventBrands.vue?vue&type=style&index=0&id=ab0deed2&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports